import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
  gap: 1rem;

  @media (max-width: 768px) {
    align-items: center;
  }
`
